module.exports = __webpack_public_path__ + "img/outlook.a9ad0ed1.svg";